"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/*
  The MIT License

  Copyright (c) 2017-2019 EclipseSource Munich
  https://github.com/eclipsesource/jsonforms

  Permission is hereby granted, free of charge, to any person obtaining a copy
  of this software and associated documentation files (the "Software"), to deal
  in the Software without restriction, including without limitation the rights
  to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
  copies of the Software, and to permit persons to whom the Software is
  furnished to do so, subject to the following conditions:

  The above copyright notice and this permission notice shall be included in
  all copies or substantial portions of the Software.

  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
  IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
  FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
  AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
  LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
  OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
  THE SOFTWARE.
*/
var merge_1 = __importDefault(require("lodash/merge"));
var react_1 = __importDefault(require("react"));
var core_1 = require("@jsonforms/core");
var react_2 = require("@jsonforms/react");
var Radio_1 = __importDefault(require("@material-ui/core/Radio"));
var RadioGroup_1 = __importDefault(require("@material-ui/core/RadioGroup"));
var core_2 = require("@material-ui/core");
var MaterialRadioGroupControl = /** @class */ (function (_super) {
    __extends(MaterialRadioGroupControl, _super);
    function MaterialRadioGroupControl() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MaterialRadioGroupControl.prototype.render = function () {
        var _this = this;
        var _a = this.props, config = _a.config, id = _a.id, label = _a.label, required = _a.required, description = _a.description, errors = _a.errors, data = _a.data, schema = _a.schema, visible = _a.visible;
        var isValid = errors.length === 0;
        var appliedUiSchemaOptions = merge_1.default({}, config, this.props.uischema.options);
        var showDescription = !core_1.isDescriptionHidden(visible, description, this.state.isFocused, appliedUiSchemaOptions.showUnfocusedDescription);
        var options = schema.enum;
        return (react_1.default.createElement(core_2.Hidden, { xsUp: !visible },
            react_1.default.createElement(core_2.FormControl, { component: 'fieldset', fullWidth: !appliedUiSchemaOptions.trim },
                react_1.default.createElement(core_2.FormLabel, { htmlFor: id, error: !isValid, component: 'legend' }, core_1.computeLabel(core_1.isPlainLabel(label) ? label : label.default, required, appliedUiSchemaOptions.hideRequiredAsterisk)),
                react_1.default.createElement(RadioGroup_1.default, { value: this.state.value, onChange: function (_ev, value) { return _this.handleChange(value); }, row: true }, options.map(function (optionValue) { return (react_1.default.createElement(core_2.FormControlLabel, { value: optionValue, key: optionValue, control: react_1.default.createElement(Radio_1.default, { checked: data === optionValue }), label: optionValue })); })),
                react_1.default.createElement(core_2.FormHelperText, { error: !isValid }, !isValid ? errors : showDescription ? description : null))));
    };
    return MaterialRadioGroupControl;
}(react_2.Control));
exports.MaterialRadioGroupControl = MaterialRadioGroupControl;
exports.materialRadioGroupControlTester = core_1.rankWith(2, core_1.optionIs('format', 'radio'));
exports.default = react_2.withJsonFormsControlProps(MaterialRadioGroupControl);
//# sourceMappingURL=MaterialRadioGroupControl.js.map